import { ConnectedPosition, Overlay, OverlayConfig } from '@angular/cdk/overlay';
import { ElementRef } from '@angular/core';

const defaultPosition: ConnectedPosition = {
  originX: 'end',
  originY: 'bottom',
  overlayX: 'end',
  overlayY: 'top',
};

export const fullscreenConfig = (overlay: Overlay): OverlayConfig => ({
  hasBackdrop: true,
  backdropClass: 'cdk-overlay-transparent-fullscreen',
  scrollStrategy: overlay.scrollStrategies.block(),
  positionStrategy: overlay.position().global().top().left().right().bottom(),
});

export const bottomConfig = (overlay: Overlay): OverlayConfig => ({
  hasBackdrop: true,
  scrollStrategy: overlay.scrollStrategies.block(),
  minWidth: '100vw',
  disposeOnNavigation: true,
  positionStrategy: overlay.position().global().top().left().right().bottom('0'),
});

export const centerConfig = (overlay: Overlay): OverlayConfig => ({
  hasBackdrop: true,
  backdropClass: 'cdk-overlay-dark-backdrop',
  scrollStrategy: overlay.scrollStrategies.block(),
  positionStrategy: overlay.position().global().centerHorizontally().centerVertically(),
  panelClass: 'rma-overlay-panel',
});

export const attachedConfig = (overlay: Overlay, elRef: ElementRef, position: ConnectedPosition = defaultPosition): OverlayConfig => ({
  hasBackdrop: true,
  backdropClass: 'cdk-overlay-transparent-backdrop',
  scrollStrategy: overlay.scrollStrategies.close(),
  positionStrategy: overlay.position().flexibleConnectedTo(elRef).withPositions([position]),
});

export const dropdownMenuConfig = (
  overlay: Overlay,
  elRef: ElementRef,
  position: ConnectedPosition = {
    originX: 'start',
    originY: 'bottom',
    overlayX: 'start',
    overlayY: 'top',
  },
): OverlayConfig => ({
  hasBackdrop: true,
  backdropClass: 'cdk-overlay-transparent-backdrop',
  minWidth: elRef.nativeElement.getBoundingClientRect().width - 1,
  scrollStrategy: overlay.scrollStrategies.close(),
  positionStrategy: overlay
    .position()
    .flexibleConnectedTo(elRef)
    .withPositions([position])
    .withDefaultOffsetY(-2)
    .withDefaultOffsetX(1)
    .withFlexibleDimensions(false),
});

export const popoverConfig = (
  overlay: Overlay,
  elRef: ElementRef,
  position: ConnectedPosition = {
    originX: 'center',
    originY: 'bottom',
    overlayX: 'center',
    overlayY: 'top',
  },
): OverlayConfig => ({
  hasBackdrop: true,
  backdropClass: 'cdk-overlay-transparent-backdrop',
  scrollStrategy: overlay.scrollStrategies.close(),
  positionStrategy: overlay.position().flexibleConnectedTo(elRef).withPositions([position]),
});
